var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAscentVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1981.402px",
    height: "200px",
    viewBox: "0 0 1981.402 200",
    enableBackground: "new 0 0 1981.402 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    d: "M1048.755,192.259l24.736-163.497  M1048.755,28.762l24.736,163.497 M1132.25,9.218l-39.418,19.544 M1132.25,28.762L990.114,9.218l42.213,19.544 M1073.492,28.762 h-24.775L990.114,9.218l70.989,19.544l71.146-19.544 M990.114,28.762L1132.25,9.218l-58.758,19.544 M1132.25,28.762h-58.758 v163.497h-24.775V28.762h-58.602V9.218h142.135V28.762L1132.25,28.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    d: "M821.183,50.947L796.484,9.218  M909.998,150.219v42.04 M821.183,50.947l113.593,141.312 M821.183,9.218l88.815,183.041 M821.183,192.259L796.484,9.218  M821.183,9.218l-24.697,183.041 M934.774,192.259L909.998,9.218l24.776,42.585l-24.776,140.456 M934.774,192.259h-24.776 L821.959,50.675l-0.777,0.272v141.312h-24.697V9.218h24.697l88.078,141.273l0.737-0.272V9.218h24.776L934.774,192.259 L934.774,192.259z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    d: "M717.106,107.829h-83.533v64.925h96.271 v19.467l-120.932,0.038V9.878h119.535v19.467h-94.873v59.018h83.533L717.106,107.829L717.106,107.829z M728.446,9.878 l-94.873,19.467L608.911,192.22l120.932-19.467 M729.843,192.259l-96.271-19.505l-24.662,19.505 M728.446,29.345L608.911,9.878 l24.662,162.876 M717.106,88.362l-83.533,19.506V88.362l83.533,19.506 M633.573,107.829L608.911,9.878l24.662,78.484  M608.911,192.259l24.662-103.896 M608.911,192.259l24.662-84.391"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    d: "M407.554,75.348h24.155l-24.506,40.563  M541.805,66.993L475.903,7.741l-68.351,67.606l23.921,40.563h-24.271l68.7,76.309l65.9-59.484 M541.572,131.996l0.231,0.777 c0.352,16.824-5.592,30.928-17.747,42.351c-12.115,11.384-28.192,17.135-48.153,17.135c-20.272,0-36.777-7.228-49.594-21.563 c-12.736-14.377-19.105-32.598-19.105-54.668V84.129c0-22.108,6.369-40.369,19.105-54.746 c12.777-14.414,29.32-21.602,49.594-21.602c20.311,0,36.427,5.399,48.427,16.24c11.96,10.841,17.825,25.138,17.475,42.972 l-0.231,0.777h-23.302c0-12.588-3.688-22.535-11.065-29.839c-7.38-7.306-17.826-10.958-31.301-10.958 c-13.556,0-24.351,5.439-32.391,16.358c-8.039,10.879-12.039,24.399-12.039,40.524v32.055c0,16.318,4,29.917,12.039,40.797 c8.04,10.917,18.835,16.396,32.391,16.396c13.475,0,23.921-3.652,31.301-10.918c7.378-7.268,11.065-17.328,11.065-30.149h23.302 L541.572,131.996L541.572,131.996z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    x1: 277.456,
    y1: 192.259,
    x2: 277.456,
    y2: 173.221
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    x1: 211.593,
    y1: 138.252,
    x2: 278.273,
    y2: 192.259
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    points: "340.37,63.226 277.417,9.218  216.215,57.94 276.098,110.743 276.098,87.937 341.845,144.585 278.273,192.259 278.273,173.221  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    d: "M317.767,144.816 c0-8.08-3.066-14.842-9.165-20.318c-6.135-5.439-16.932-10.025-32.502-13.755c-18.835-4.507-33.515-11.112-44.078-19.814 c-10.485-8.781-15.805-19.738-15.805-32.988c0-13.87,5.669-25.448,17.047-34.735c11.34-9.325,26.097-13.987,44.194-13.987 c19.457,0,34.952,5.323,46.486,16.047c11.493,10.686,17.049,23.079,16.658,37.183l-0.23,0.778h-22.952 c0-10.452-3.456-18.884-10.369-25.333c-6.874-6.45-16.737-9.636-29.592-9.636c-11.96,0-21.203,2.68-27.572,8.082 c-6.369,5.439-9.592,12.472-9.592,21.214c0,7.691,3.457,14.144,10.369,19.31c6.951,5.168,18.214,9.714,33.748,13.599 c18.718,4.624,33.009,11.462,42.757,20.516c9.786,9.055,14.68,20.242,14.68,33.608c0,14.338-5.863,25.877-17.593,34.581 c-11.728,8.74-27.067,13.094-45.979,13.094c-17.709,0-33.437-4.856-47.069-14.531c-13.631-9.676-20.271-22.651-19.845-38.736 l0.234-0.738h22.951c0,11.385,4.194,20.088,12.583,26.032c8.388,5.942,18.795,8.937,31.146,8.937 c12.155,0,21.786-2.563,28.892-7.652C314.233,160.477,317.767,153.561,317.767,144.816L317.767,144.816z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1F76BC",
    strokeWidth: 0.6121,
    strokeMiterlimit: 10,
    d: "M122.157,144.741H44.914L27.399,192.22H2.002 L73.263,7.741h21.398l70.135,184.479H139.36L122.157,144.741L122.157,144.741z M52.604,123.76h62.058l-30.37-83.964h-0.777 L52.604,123.76L52.604,123.76z M27.399,192.259L73.263,7.781L52.604,123.76 M73.263,7.781L44.914,144.779L2.002,192.221 l50.602-68.461 M139.36,192.259L94.662,7.781l20.66,115.979 M94.662,7.781l28.349,136.998l41.786,47.438l-49.475-68.46  M52.604,123.76l69.553,21.021 M114.662,123.76L44.914,144.78"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscentVector);
export default __webpack_public_path__ + "static/media/ascentVector.559c01cf800c28994fea6dd7df5de334.svg";
export { ForwardRef as ReactComponent };